'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

exports.default = function (inBuffer, bitmapInfo) {
  var outBuffers = [];
  var reader = new _syncReader2.default(inBuffer);
  var filter = new _parse2.default(bitmapInfo, {
    read: reader.read.bind(reader),
    write: function write(bufferPart) {
      outBuffers.push(bufferPart);
    },
    complete: function complete() {}
  });

  filter.start();
  reader.process();

  return Buffer.concat(outBuffers);
};

var _syncReader = require('../sync-reader');

var _syncReader2 = _interopRequireDefault(_syncReader);

var _parse = require('./parse');

var _parse2 = _interopRequireDefault(_parse);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./node_modules/pngjs3/dist/filter/parse-sync.js
// module id = 1088
// module chunks = 0